import { combineReducers } from 'redux';
import { pathOr, indexBy, prop } from 'ramda';
import { createSelector } from 'reselect';
import { SET_GAMES } from '../../../constants/games';
import {
  createAllIdsTypeReducer,
  createEntityMapTypeReducer,
} from '../../../helpers/reducerCreator';
import { getListWithStatus } from '../../../helpers/selector';
import { isDebugModeSelector } from '../../app/initialization';

export const initialState = {
  allIds: [],
  byId: {},
};

export default combineReducers({
  allIds: createAllIdsTypeReducer(SET_GAMES, initialState.allIds),
  byId: createEntityMapTypeReducer(SET_GAMES, initialState.byId),
});

const rootSelector = (state) =>
  pathOr(initialState, ['domain', 'games'], state);

export const gameListSelector = createSelector(
  rootSelector,
  isDebugModeSelector,
  getListWithStatus(({ byId, allIds }) => allIds.map((id) => byId[id]))
);

export const gamesByIdSelector = createSelector(
  gameListSelector,
  indexBy(prop('id'))
);

export const gameItemSelector = (state, id) =>
  pathOr({}, [id], gamesByIdSelector(state));
